module.exports = __webpack_public_path__ + "static/img/02560_5.e8ff940.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/02560_5.jpg
// module id = TUay
// module chunks = 1